import React, {Component} from 'react';
import FormView from './FormView'
import FormViewContainer from '../../../components/Letflow/ViewContainer/FormViewContainer';
import {getUpdateFormImageUrlFromItem} from "../../../utils";
class FormContainer extends Component {

  state = {
    nameEs: '',
    nameEn: '',
    namePt: '',
    slug: '',
    image: {src: null, file: null},
    disabled: false,
    showOnSmartSearch: true,
    type: this.props.isTalent ? 'talent' : this.props.isAudiovisual ? 'audiovisual' : 'editorial',
    synonyms: "",
    brand: "bloomclouds",
  };

  setContentCreatorType = contentCreatorType => {
    let translationEs = contentCreatorType.translations.find(translation => translation.locale === 'es')
    let translationEn = contentCreatorType.translations.find(translation => translation.locale === 'en')
    let translationPt = contentCreatorType.translations.find(translation => translation.locale === 'pt')

    this.setState({
      nameEs: translationEs && translationEs.name,
      nameEn: translationEn && translationEn.name,
      namePt: translationPt && translationPt.name,
      slug: contentCreatorType.slug,
      showOnSmartSearch: contentCreatorType.show_on_smart_search,
      image: {
        src: getUpdateFormImageUrlFromItem(contentCreatorType),
        file: null
      },
      type: contentCreatorType.type,
      synonyms: contentCreatorType.synonyms,
      brand: contentCreatorType.brand,
    })
  }

  onChange = e => this.setState({ [e.target.id]: e.target.value })

  onImageChange = image => this.setState({ image })

  submitRequest = () => this.props.submitRequest(this.state)

  onSubmitValidation = () => {
      return true
  }

  render = () => {

    const { nameEs, nameEn, namePt, slug, disabled, image, showOnSmartSearch, type, synonyms, brand} = this.state

    return (
      <FormViewContainer
        title={this.props.title}
        submitRequest={this.submitRequest}
        onBack={() => this.props.history.goBack()}
        initializationRequest={this.props.initializationRequest}
        onRequestingStateChanged={value => this.setState({ disabled: value })}
        hasTranslatableInputs
        validation={this.onSubmitValidation}
      >
        <FormView
          ref={instance => this.child = instance}
          disabled={disabled}
          nameEs={nameEs}
          nameEn={nameEn}
          namePt={namePt}
          slug={slug}
          showOnSmartSearch={showOnSmartSearch}
          onShowOnSmartSearchChange={showOnSmartSearch => this.setState({showOnSmartSearch})}
          onChange={this.onChange}
          image={image}
          onImageChange={this.onImageChange}
          isUpdating={this.props.isUpdating}
          type={type}
          creationForm={this.props.creationForm}
          synonyms={synonyms}
          brand={brand}
        />
      </FormViewContainer>
    )
  }
}

export default FormContainer
